module.exports = __webpack_public_path__ + "static/img/gwiazdawr.585ecb30.webp";